export default "__VITE_ASSET__BCXnbG8T__"